import styled, { css } from "styled-components";
import MediaQueries from "../../settings/mediaQueries";
import { Colors } from "../../settings/colors";
import { Link } from "react-router-dom";

export const MenuContainer = styled.div`
    width: 300px;
    display: flex;
    flex-direction: column;
    background: ${Colors.Main};
    padding: 0;
    display: none;
    padding-top: 20px;
    border-top-right-radius: 25px;

    ${MediaQueries.BIGGER_THAN_TABLET} {
        display: flex;
    }
`;

export const MenuHeader = styled.header`
    display: flex;
    padding: 30px;
    margin-bottom: 20px;
    flex-direction: column;

    img {
        width: 55px;
        height: 55px;
        border-radius: 8px;
        margin-bottom: 15px;
        transition: width 0.2s, height 0.2s;

        :hover {
            width: 100%;
            height: unset;
            transition: width 0.2s, height 0.2s;
        }
    }

    strong {
        color: ${Colors.LightText};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 2rem;
        margin-bottom: 10px;
    }
`;

export const MenuList = styled.div`
    display: flex;
    flex-direction: column;
    padding-left: 0px;
    padding-left: 10px;
`;

export const MenuLink = styled(Link)<{ active: boolean }>`
    width: 100%;
    margin-bottom: 10px;
    padding: 15px;
    padding-left: 20px;
    text-decoration: none;
    color: ${Colors.Secondary};
    position: relative;
    font-size: 1.2rem;
    font-weight: bold;

    :hover {
        color: ${Colors.LightText};
    }

    ${({ active }) =>
        active &&
        css`
            color: ${Colors.Main};
            background: #fff;
            border-top-left-radius: 25px;
            border-bottom-left-radius: 25px;

            :hover {
                color: ${Colors.Main};
            }

            > span {
                content: " ";
                position: absolute;
                width: 40px;
                height: 40px;
                right: 0;
                background: #fff;
                top: -50%;
                height: 200%;
            }

            :after {
                content: " ";
                position: absolute;
                width: 40px;
                height: 40px;
                right: 0;
                top: 100%;
                background: ${Colors.Main};
                z-index: 1;
                border-top-right-radius: 25px;
            }

            :before {
                content: " ";
                position: absolute;
                width: 40px;
                height: 40px;
                right: 0;
                bottom: 100%;
                background: ${Colors.Main};
                z-index: 1;
                border-bottom-right-radius: 25px;
            }
        `};
`;
